import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ConfigFacade } from '@library/store/config/config.facade';
import { EnumNavigationDirections, GLOBAL_NAVCOUNTER, NavigationCounter } from '@library/utils/services/navigation-counter.service';
import { UserAgentService } from '@library/utils/services/user-agent.service';
import { map, skip, tap } from 'rxjs/operators';
import { slideInAnimation } from './route-animation';

@Component({
  selector: 'lay-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [slideInAnimation],
  standalone: false,
})
export class MainComponent implements OnInit {
  userAgent = inject(UserAgentService);
  private readonly counter = inject<NavigationCounter>(GLOBAL_NAVCOUNTER);
  configFacade = inject(ConfigFacade);

  lastTransition = null;

  animation$ = this.counter.currentDirection$.pipe(
    skip(1), // neglect the navigation event of entering the web app
    map((direction) => {
      if (direction === EnumNavigationDirections.Forward) {
        return this.lastTransition === 'Forward' ? 'ForwardAgain' : 'Forward';
      }
      else {
        return this.lastTransition === 'Backward' ? 'BackwardAgain' : 'Backward';
      }
    }),
    tap(transition => {
      this.lastTransition = transition;
    }),
  );

  @HostBinding('class') class = 'is-fullheight is-fullwidth';

  ngOnInit() {
    this.setDeviceClasses();
    this.counter.startCounting();
  }

  isWebappMode() {
    return this.configFacade.getWebappMode();
  }

  /**
   * Add device environement classes to body
   * depends on user agent
   */
  setDeviceClasses() {
    if (this.userAgent.isNativeApp()) {
      document.body.classList.add('is-native');
    }

    if (this.userAgent.isMobile()) {
      document.body.classList.add('is-mobile');
    }
    else {
      document.body.classList.add('is-desktop');
    }

    if (this.userAgent.isIos()) {
      document.body.classList.add('is-ios');
      document.body.classList.add(
        `is-ios-version-${this.userAgent.iosVersion().trim()}`,
      );
    }

    if (this.userAgent.isAndroid()) {
      document.body.classList.add('is-android');
    }
  }
}
